// utils.js
export const getStatusDot = (status) => {
  let dotColor;
  switch (status) {
    case "Submitted":
      dotColor = "#6c757d";
      break;
    case "Review Fee Due":
      dotColor = "#fd7e14";
      break;
    case "Review Fee Paid":
      dotColor = "#20c997";
      break;
    case "Pending":
      dotColor = "orange";
      break;
    case "Village Fees Due":
      dotColor = "#dc3545";
      break;
    case "Village Fees Paid":
      dotColor = "#198754";
      break;
    case "Rejected":
      dotColor = "red";
      break;
    case "On Hold":
      dotColor = "gray";
      break;
    case "Approved":
      dotColor = "green";
      break;
    case "Finalized":
      dotColor = "#1a73e8";
      break;
    case "Void":
      dotColor = "darkred";
      break;
    default:
      dotColor = "gray";
  }

  return (
    <span className="d-flex align-items-center">
      <span
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: dotColor,
          marginRight: "8px",
        }}
      ></span>
      {status}
    </span>
  );
};

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};
  